<template>
  <div class="pages">
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: 'Pages',
    created() {
      this.$router.replace('/') //  Set initital page
    }
  }
</script>

<style lang="scss">
  //
  //  All default page styling
  //
  .page {
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 960px;
    margin: 0 auto;
    padding: 0 40px 40px 40px;
    font-family: $font-base;

    h2 {
      max-width: 600px;
      margin: 0;
      padding: 0;
      font-size: 2.5rem;
      font-weight: bold;
      text-transform: none;
      color: $color-primary;
    }
    h3 {
      max-width: 600px;
      font-size: 1.75rem;
      font-weight: bold;
      text-transform: none;
      color: white;
    }
    form {
      display: flex;
      flex-direction: column;
      margin: 40px 0;

      .form-row {
        display: flex;
        flex-direction: row;
        width: 100%;

        .form-col {
          width: auto;
          min-height: 80px;
          margin-right: 30px;

          &.form-col-zip {
            width: 100%;
            max-width: 136px;
          }
          &.form-col-small {
            width: 100%;
            max-width: 104px;
          }
          &.form-col-medium {
            width: 100%;
            max-width: 240px;
          }
          &.form-col-large {
            width: 100%;
            max-width: 480px;
          }
          &.form-col-full {
            width: 100%;
            max-width: 100%;
          }
        }
      }
    }
    label {
      color: $color-primary;
      font-weight: bold;
      font-size: 0.85rem;
      user-select: none;
    }
    input {
      &[type="text"],
      &[type="phone"],
      &[type="number"],
      &[type="email"]{
        display: block;
        float: left;
        width: 100%;
        border-collapse: collapse;
        border: 0;
        padding: 3px 0 5px 0;
        font-size: 2rem;
        font-weight: bold;
        color: $color-primary;
        background-color: $color-yellow-1;
        box-shadow: 0px -2px $color-primary inset;
        transition: all .150s;
        &::placeholder {
          color: $color-yellow-dark;
        }
        &:focus {
          border: 0;
          outline: 0;
          box-shadow: 0px -4px $color-primary inset;
          transition: all .350s;
        }
      }
      &[type="checkbox"] {
        color: $color-primary;
        &+label{
          margin-left: 10px;
          font-size: 1rem;
        }
      }
    }

    .invalid {
      label {
        color: $color-invalid;
      }
      input {
        color: $color-invalid;
        box-shadow: 0px -2px $color-invalid inset;
        &:focus {
          box-shadow: 0px -4px $color-invalid inset;
        }
      }
    }

    .paragraph {
      line-height: 1.5em;
      color: $color-primary;
    }
    
    .nav-buttons {
      padding-top: 60px;

      button {
        display: inline-block;
        border: 0;
        padding: 15px 45px;
        color: $color-yellow-2;
        font-weight: bold;
        text-transform: none;
        background-color: $color-yellow-dark;
        transition: all 350ms;
        cursor: pointer;
        user-select: none;

        &.enabled {
          color: white;
          background-color: $color-primary;

          &:hover, &:focus {
            box-shadow: 3px 3px 6px rgba(0,0,0,0.2);
            outline: 0;
            transition: all 350ms;
          }
        }
      }
    }

  }
</style>
